import * as React from 'react';
import { connect } from 'react-redux';
import { RequestApiResult, requestAPIActions, IsAuthentificatedState } from 'loopback-react-request';
import { UserModel } from 'franke-trough-dependencies';
import { assign as _assign } from 'lodash';

export interface UserDispatcherProps {
  authenticator: IsAuthentificatedState;
  dispatch: any;
  user: RequestApiResult<UserModel>;
}

const dispatchKey = 'user';

class UserDispatcherContainer extends React.Component<UserDispatcherProps, any> {

  componentDidMount() {
    this.dispatchUser();
  }

  public render() {
    return null;
  }

  private dispatchUser() {
    const {
      authenticator,
    } = this.props;

    const queryParams = _assign({}, {
      include: ['managers', 'managees', 'roles']
    });

    if (authenticator.accessToken) {
      this.props.dispatch(requestAPIActions.load(dispatchKey, {
        url: `/Users/${authenticator.accessToken.userId}`,
        queryParams
      }));
    }
  }
}

interface StateProps {
  authenticator: IsAuthentificatedState;
  user: RequestApiResult<UserModel>;
}

export const UserDispatcher = connect((state: StateProps) => ({
  authenticator: state.authenticator,
  user: state.user,
}))(UserDispatcherContainer);
